// themeRipple.js — Subtle background ripple on theme-toggle press

const RIPPLE_BASE_SIZE_PX = 22;
const RIPPLE_DURATION_MS = 1800;

function prefersReducedMotion() {
  return typeof window.matchMedia === 'function'
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function getNextThemeColor() {
  const current = document.documentElement.dataset.theme;
  return current === 'dark'
    ? 'rgba(26, 92, 56, 0.16)'
    : 'rgba(0, 230, 138, 0.14)';
}

function launchBackgroundRipple(originX, originY) {
  if (prefersReducedMotion()) return;

  const maxRadius = Math.hypot(
    Math.max(originX, window.innerWidth - originX),
    Math.max(originY, window.innerHeight - originY)
  );
  const targetScale = (maxRadius * 2) / RIPPLE_BASE_SIZE_PX;
  const ripple = document.createElement('div');

  ripple.dataset.themeRipple = 'true';
  Object.assign(ripple.style, {
    position: 'fixed',
    left: `${originX}px`,
    top: `${originY}px`,
    width: `${RIPPLE_BASE_SIZE_PX}px`,
    height: `${RIPPLE_BASE_SIZE_PX}px`,
    borderRadius: '999px',
    pointerEvents: 'none',
    zIndex: '0',
    opacity: '0',
    transform: 'translate(-50%, -50%) scale(0.35)',
    background: `radial-gradient(circle, ${getNextThemeColor()} 0%, transparent 68%)`,
    filter: 'blur(1px)',
  });

  document.body.appendChild(ripple);

  function removeRipple() {
    ripple.remove();
  }

  if (typeof ripple.animate !== 'function') {
    window.setTimeout(removeRipple, RIPPLE_DURATION_MS);
    return;
  }

  const anim = ripple.animate(
    [
      { opacity: 0, transform: 'translate(-50%, -50%) scale(0.35)' },
      { opacity: 1, offset: 0.18 },
      { opacity: 0, transform: `translate(-50%, -50%) scale(${targetScale})` },
    ],
    {
      duration: RIPPLE_DURATION_MS,
      easing: 'cubic-bezier(0.12, 0.72, 0.24, 1)',
      fill: 'forwards',
    }
  );

  anim.onfinish = removeRipple;
  anim.oncancel = removeRipple;
}

function getButtonCenter(btn) {
  const rect = btn.getBoundingClientRect();
  return {
    x: Math.round(rect.left + rect.width / 2),
    y: Math.round(rect.top + rect.height / 2),
  };
}

export function initThemeRipple() {
  const btn = document.getElementById('theme-toggle');
  if (!btn) return;

  btn.addEventListener('pointerdown', (event) => {
    launchBackgroundRipple(event.clientX, event.clientY);
  });

  btn.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    const { x, y } = getButtonCenter(btn);
    launchBackgroundRipple(x, y);
  });
}
